import { useMemo, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { UserData } from '../../types';
import { computeFeatureUsage, formatDateLabel } from '../../lib/metrics';

interface FeatureUsageChartProps {
  users: UserData[];
  fullWidth?: boolean;
}

export function FeatureUsageChart({ users, fullWidth = true }: FeatureUsageChartProps) {
  const [range, setRange] = useState<'7d' | '30d' | 'all'>('30d');

  const data = useMemo(() => {
    const days = range === '7d' ? 7 : range === '30d' ? 30 : 90;
    return computeFeatureUsage(users, days).map(d => ({
      date: formatDateLabel(d.date),
      Chat: d.chat,
      Discovery: d.discover,
      Gist: d.gist,
      'Citation Click': d.citationClick,
      'Panel Open': d.timePanel,
    }));
  }, [users, range]);

  return (
    <div className={`chart-card${fullWidth ? ' chart-full-width' : ''}`}>
      <div className="chart-header">
        <h3>Feature Usage</h3>
        <div className="chart-range-toggle">
          <button className={range === '7d' ? 'active' : ''} onClick={() => setRange('7d')}>7d</button>
          <button className={range === '30d' ? 'active' : ''} onClick={() => setRange('30d')}>30d</button>
          <button className={range === 'all' ? 'active' : ''} onClick={() => setRange('all')}>All</button>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={fullWidth ? 280 : 250}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="date" fontSize={11} tick={{ fill: '#6b7280' }} />
          <YAxis fontSize={11} tick={{ fill: '#6b7280' }} allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Bar dataKey="Chat" stackId="a" fill="#3b82f6" radius={[0, 0, 0, 0]} />
          <Bar dataKey="Discovery" stackId="a" fill="#f59e0b" />
          <Bar dataKey="Gist" stackId="a" fill="#10b981" />
          <Bar dataKey="Citation Click" stackId="a" fill="#8b5cf6" />
          <Bar dataKey="Panel Open" stackId="a" fill="#ec4899" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
